import React from "react"
import PropTypes from "prop-types"
import { Button, Spacer } from "../../bits"
import { FormField, Select, Input, TextArea } from "../../forms"
import { Formik, Form, Field } from "formik"
import * as yup from "yup"
import { useTranslation } from "react-i18next"
import axios from "axios"
import { toast } from "react-toastify"

const FileRequestForm = ({ hash_id, className }) => {
  const { t, i18n } = useTranslation()

  const validationSchema = React.useMemo(() => {
    return yup.object().shape({
      name: yup.string().required(t("validation.required")),
      firstname: yup.string().required(t("validation.required")),
      email: yup
        .string()
        .email(t("validation.email"))
        .required(t("validation.required")),
      phone: yup.string().required(t("validation.required")),
      zipcode: yup.string().nullable(),
      message: yup.string().max(10240).nullable(),
      city: yup.string().nullable(),
      country: yup.string().nullable(),
    })
  }, [t])

  return (
    <Formik
      initialValues={{
        name: "",
        firstname: "",
        email: "",
        phone: "",
        message: t("request_form.message_body"),
        zipcode: "",
        city: "",
        country: "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        axios
          .post(`/api/realestate/property/${hash_id}/file-applications`, {
            first_name: values.firstname,
            last_name: values.name,
            phone: values.phone,
            email: values.email,
            message: values.message,
            locale: i18n.language,
            zip_code: values.zipcode,
            city: values.city,
            country: values.country,
            has_accepted_privacy_policy: true,
          })
          .then(() => {
            toast.success(t("request_form.success"))
          })
          .catch(err => {
            toast.error(t("request_form.error"))
            console.error(err)
          })
          .finally(() => {
            actions.setSubmitting(false)
          })
      }}
    >
      {({ isSubmitting }) => (
        <Form className={className}>
          <Spacer gap="xsmall" direction="row" noWrap>
            <FormField
              name="firstname"
              title={t("request_form.firstname")}
              required
            >
              <Field component={Input} name="firstname" />
            </FormField>
            <FormField name="name" title={t("request_form.name")} required>
              <Field component={Input} name="name" />
            </FormField>
          </Spacer>
          <FormField name="email" title={t("request_form.email")} required>
            <Field component={Input} name="email" />
          </FormField>
          <FormField name="phone" title={t("request_form.phone")} required>
            <Field component={Input} name="phone" />
          </FormField>
          <FormField name="message" title={t("request_form.message")}>
            <Field component={TextArea} name="message" />
          </FormField>
          <details>
            <summary>{t("request_form.more_infos")}</summary>
            <Spacer gap="xsmall" direction="row" noWrap>
              <FormField
                name="zipcode"
                title={t("request_form.zipcode")}
                style={{ flex: "0 0 110px" }}
              >
                <Field component={Input} name="zipcode" />
              </FormField>
              <FormField
                name="city"
                title={t("request_form.city")}
                style={{ flex: "1 1 auto" }}
              >
                <Field component={Input} name="city" />
              </FormField>
            </Spacer>
            {/* <FormField name="country" title={t("request_form.country")}>
              <Field component={Select} options={countries} name="country" />
            </FormField> */}
          </details>
          <Button
            style={{ marginTop: "20px" }}
            submit
            primary
            disabled={isSubmitting}
            label={t("form.buttonSubmit")}
            fill
          />
          <div
            style={{ marginTop: "16px", fontSize: "12px", lineHeight: 1.2 }}
            dangerouslySetInnerHTML={{
              __html: t("form.by_submitting_you_accept_our_privacy_policy", {
                privacyPolicyUrl: t("urls:privacyPolicy"),
                termsAndConditionsUrl: t("urls:termsAndConditions"),
              }),
            }}
          />
        </Form>
      )}
    </Formik>
  )
}

FileRequestForm.propTypes = {
  hash_id: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export { FileRequestForm }
